module.exports = __webpack_public_path__ + "media/images/icons/media-skip-forward-96e0ec9013dbb10161684923130c1762.svg";